import {
  getIBLSEARCHURL,
  getTenant,
  getUserId,
  getUserName,
  getYearDateRange, orgSearch,
} from '../helpers';
import { api } from './api';
import any = jasmine.any;

export function getUserMonthlyActivityAPI(callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdperlearner.perlearnerOrgsUsersInfoRetrieve(...args),
    getTenant(),
    getUserName(),
    { meta: 'true' },
  )((err, data, response) => callback(data));
}

export function getUserMetadataAPI(username, callback) {
  api.ibledxusers.getUsersManageMetadata({ username }, function(data) {
    callback(data);
  });
}

export const getUserAdminCapabilities = (authorization = 'Token ' + localStorage.getItem('dm_token'))  =>  {
  const param = new URLSearchParams({
    platform_key:getTenant()
  }).toString()
  const url = process.env.REACT_APP_IBL_DM_URL + `/api/core/departments/members/check/?${param}`
  return fetch(url, {
    method: 'GET',
    //body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: authorization,
    },
  }).then((resp) : any  => {
    if(!resp.ok){
      return false
    }
    return resp.json().then((data)=>data)
  }).catch(()=>false);
}


async function getSelfReportedSkills(): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const data = {
      user_id: getUserId(),
    };
    api.ibldmskills.getUserSelfReportedSkills(data, function(_data) {
      resolve(_data?.skills);
    }, function(error) {
      resolve([]);
    });
  });
}

async function getAssignedSkills(): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const data = {
      user_id: getUserId(),
    };
    api.ibldmskills.getUserSkills(data, function(_data) {
      resolve(_data?.skills);
    }, function(error) {
      resolve([]);
    });
  });
}

async function fetchAndCheckSkills(callback) {
  try {
    const assignedSkills: any[] = await getAssignedSkills();
    const selfReportedSkills: any[] = await getSelfReportedSkills();

    // Combine assigned and self-reported skills, and check if any skills exist
    const allSkills: any[] = [...assignedSkills, ...selfReportedSkills];
    // get only the latest 5 skills
    // allSkills = allSkills.slice(0, 5);
    callback(allSkills);
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function getUserSkillsAPI(callback) {
  fetchAndCheckSkills(callback);
}

export function getSkillPointsGraphAPI(callback) {

  api.ibldmskills.getUserSkillPointInfo({
      user_id: getUserId(),
    },
    function(_data) {
      callback(_data);
    },
    function(error) {
      console.log(error);
      callback(0);
    });

}

function calculateTotalCoursePoints(data) {
  let totalCoursePoints = 0;

  for (const course in data) {
    if (data.hasOwnProperty(course)) {
      totalCoursePoints += data[course].course_points;
    }
  }

  return totalCoursePoints;
}

export function getUserLeaderBoardAPI(username, callback) {
  api.ibldmskills.getUserSkillPointInfo({
      username,
      platform_key: getTenant(),
    },
    function(_data) {
      callback(calculateTotalCoursePoints(_data));
    },
    function(error) {
      console.log(error);
      callback(0);
    });


}

export function getEngagementDataAPI(callback) {
  const start_date = getYearDateRange().start;
  const end_date = getYearDateRange().end;
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdperlearner.perlearnerOrgsUsersOverviewTimeOverTimeRetrieve(
        ...args,
      ),
    getTenant(),
    getUserName(),
    { startDate: start_date, endDate: end_date },
  )((err, data, response) => callback(data.data));
}

export function splitIntoWeeksAndMonths(data) {
  const weeksAndMonths: any[] = [];
  let week: any[] = [];
  let currentMonth: any = null;
  for (let i = 0; i < data.length; i++) {
    const entry = data[i];
    const date = new Date(entry[0]);
    const dayOfWeek = date.getDay();
    const month = date.getMonth();
    if (dayOfWeek === 0 && week.length > 0) {
      weeksAndMonths.push({ type: 'week', entries: week });
      week = [];
    }

    week.push(entry);
    currentMonth = month;
  }

  if (week.length > 0) {
    weeksAndMonths.push({ type: 'week', entries: week });
  }

  return weeksAndMonths;
}

export function getMonthLabels() {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const monthLabels: any[] = [];

  for (let i = 0; i < 13; i++) {
    const month = (currentMonth + i) % 12;
    const monthLabel = new Date(0, month).toLocaleString('en-us', {
      month: 'short',
    });
    monthLabels.push(monthLabel);
  }

  return monthLabels;
}

export function searchGetCourseMeta(data, callback) {
  const fetchData = async () => {
    try {
      const path =
        '?detail_indice={"_index":"ibl-dm.public.dl_catalog_app_course"}&detail_scope={"course_id":"' +
        data +
        '"}';
      const url = `${getIBLSEARCHURL()}/api/search/search/${path}`;

      const response = await fetch(url, { method: 'GET' });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      callback(responseData);
    } catch (error) {
      console.error(error);
      callback({ message: 'something went wrong' });
    }
  };
  fetchData();
}


export const handleProgramMetadata = (programs, callback) => {
  programs.forEach((program) => {
    const programId = program.program_id;
    const searchData = `?detail_indice={"_index":"ibl-dm.public.dl_catalog_app_program"}&detail_scope={"program_id":"${programId}"}`;
    orgSearch(searchData, (searchData) => {
      if (searchData && searchData.results && searchData.results.length > 0) {
        const detail = {
          program_id: programId,
          detail: searchData?.results[0]?._source,
        };
        callback(detail);
      }
    });
  });
};

export function isValidHttpUrl(str: string) {
  let url: URL;
  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

export function callMainTenantAPIsOnly (){
  return process.env.REACT_APP_IBL_CALL_MAIN_TENANT_APIS_ONLY === 'true'
}

export const getContentCompletionData = (queryParams:any, contentType="program", callback:(data:any)=>void) => {
  const param = new URLSearchParams(queryParams).toString()
  const url = process.env.REACT_APP_IBL_DM_URL + `/api/catalog/milestones/completions/${contentType}/query?${param}`
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((resp) : any  => {
    if(!resp.ok){
      callback({})
    }
    return resp.json().then(callback)
  }).catch(()=>callback({}))
}